import { getStateValue, getThemeData, updateStateValue } from "../utils";
import { defineNuxtPlugin } from "../.nuxt/imports";
import type { IData } from "~/interfaces";

interface crmRedirectRequest {
  cf: string,
  phone: string,
}

interface VerifyCrmResponse {
  id: string;
  prod: string;
  success: boolean;
}

const redirects: any = {
  fast: {
    type: "fast",
    url: "/fs/%d/fast",
  },
  conso: {
    type: "conso",
    url: "/cs/%d/conso",
  },
  pz: {
    type: "pz",
    url: "/cliente-pz/",
  },
  uci: {
    type: "uci",
    url: "/cliente-unicredit/",
  },
};
const data: IData = getThemeData();

export default defineNuxtPlugin(() => {
  return {
    provide: {
      crmRedirect: async () => {
        try {
          
          const payload: crmRedirectRequest = {
            cf: getStateValue("taxCode"),
            phone: getStateValue("cellphone")?.replaceAll(' ', '') ?? ''
          };

          let crmUrl = 'mega_crm_cf'

          if (data.theme === 'unicredit') {
            crmUrl = 'uci_crm_cf';
          }

          const fullUrl = `${data.endpoints.crm as string}find/`+ crmUrl;

          const response = await $fetch<VerifyCrmResponse>(
            fullUrl,
            {
              method: "POST",
              body: payload,
            },
          );


          let { id, prod, success } = response;
          

          if (prod === 'pz' && data.theme === 'unicredit' && success) {
            prod = 'uci';
          }

          if (id && prod && success) {

            if (prod === 'pz' && getStateValue("isRevolving")) {
              return false;
            }

            const queryParams = new URLSearchParams();
            const {utm_campaign, utm_medium, utm_source, utm_content} = getStateValue('urlVars', null)
            queryParams.set("utm_source", utm_source ?? "megathron")
            queryParams.set("utm_medium", utm_medium ?? "referral")
            queryParams.set("utm_campaign", utm_campaign ?? "creditocofidis")
            if (utm_content) queryParams.set("utm_content", utm_content)
            
            if (prod === 'pz'|| prod === 'uci') {
              
              if(prod === 'uci') {
                queryParams.set("utm_source", "ppunicredit")
                queryParams.set("utm_campaign", "unicredit")
              }

              queryParams.set("c", "pz")
              queryParams.set("u", id)
              queryParams.set("amount", getStateValue("credit"))
              queryParams.set("rate", getStateValue("rate"))
              queryParams.set("orderID", getStateValue("orderID"))
            }

            const redirectUrl = 
              window.location.origin +
              redirects[prod].url.replace("%d", id) + 
              '?' + queryParams.toString();

            const isCustomerService = getStateValue('isCustomerService', false);
            
            const initializeConfig = {
              show: true,
              type: redirects[prod].type,
              redirectUrl: redirectUrl,
              redirectTimeout: isCustomerService ? null : window.setTimeout(() => {

                location.href = redirectUrl;
                
              }, 7000),
              redirectVerified: true,
            };

            updateStateValue("crmModal", initializeConfig);
          } 
          return success;
        } catch (error) {
          console.error("Error in crmRedirect", error);
          return false;
        }
      },
    },
  };
});
